module.exports = __webpack_public_path__ + "static/media/Rubik-Italic.5ca63c01.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@shoutem/ui/fonts/Rubik-Italic.ttf
// module id = 1262
// module chunks = 0